import React, { MouseEventHandler } from 'react';
import { AtlassianBlue300 } from '@trello/colors';

import { ArrowRight } from './icons/ArrowRight';

import styles from './PrimaryLink.less';

interface PrimaryLinkProps {
  url: string;
  text: string;
  onClick?: MouseEventHandler;
  tabIndex?: number;
}

export const PrimaryLink: React.FunctionComponent<PrimaryLinkProps> = ({
  url,
  text,
  onClick,
  tabIndex,
}) => {
  return (
    <a
      className={styles.primaryLink}
      href={url}
      onClick={onClick}
      tabIndex={tabIndex}
    >
      {text}
      <ArrowRight color={AtlassianBlue300} />
    </a>
  );
};
